import { render } from "./BulkActions.vue?vue&type=template&id=749f16c3&scoped=true"
import script from "./BulkActions.vue?vue&type=script&lang=js"
export * from "./BulkActions.vue?vue&type=script&lang=js"

import "./BulkActions.vue?vue&type=style&index=0&id=749f16c3&lang=scss&scoped=true"
import "./BulkActions.vue?vue&type=style&index=1&id=749f16c3&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749f16c3"]])

export default __exports__